package com.eladfinish.bible.contest.ui.ads

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier

// No AdMob equivalent on Web; no ads on Web for now (see project decision).
@Composable
actual fun SearchNativeAd(
    adLabel: String,
    modifier: Modifier,
) {
}
